import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { BRANDS, resolveBrand } from './brands';

const BrandContext = createContext(BRANDS.default);

export const useBrand = () => useContext(BrandContext);

export function BrandProvider({ children, hostname }) {
  const brand = useMemo(() => {
    const host = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
    return resolveBrand(host);
  }, [hostname]);

  useEffect(() => {
    const root = document.documentElement;
    if (brand?.colors) {
      Object.entries(brand.colors).forEach(([token, value]) => {
        root.style.setProperty(`--${token}`, value);
      });
    }
    if (brand?.name && typeof document !== 'undefined') {
      document.title = brand.name;
    }
  }, [brand]);

  return (
    <BrandContext.Provider value={brand || BRANDS.default}>
      {children}
    </BrandContext.Provider>
  );
}
